import React, { useState, useEffect } from 'react';

const TopNav = ({ email }) => {
  const [currentDateTime, setCurrentDateTime] = useState('');

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      setCurrentDateTime(now.toLocaleString());
    };

    updateDateTime();
    const intervalId = setInterval(updateDateTime, 1000);
    
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="topnav">
      <a className="active" href="#">Adobe Acrobat Online</a>
      <a href="#">
        {email && <span id="result">{email.split('@')[0]}</span>}
        <span id="datetime"> {currentDateTime}</span>. - SOA.pdf
      </a>
    </div>
  );
};

export default TopNav;